$(document).ready(function(){

  if(!bq.helper.browser.isSupported()) {
    if(!bq.helper.cookies.getItem('ignored_browser_warning')) {
      $('body').html($.tmpl('unsupportedBrowser'));
      $('#ignore-browser-warning').click(function(){
        bq.helper.cookies.setItem('ignored_browser_warning', 'true', 0, '/');
        window.location = window.location.href;
      });
    }
  }

});